// BaseVibe Contract ABI
export const BaseVibeAbi = [
  {
    inputs: [{ internalType: 'enum BaseVibe.VoteOption', name: 'option', type: 'uint8' }],
    name: 'vote',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getTodayStats',
    outputs: [
      { internalType: 'uint256', name: 'positiveVotes', type: 'uint256' },
      { internalType: 'uint256', name: 'negativeVotes', type: 'uint256' },
      { internalType: 'uint256', name: 'totalVotes', type: 'uint256' },
      { internalType: 'uint256', name: 'dateKey', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'dateKey', type: 'uint256' }],
    name: 'getStatsForDate',
    outputs: [
      { internalType: 'uint256', name: 'positiveVotes', type: 'uint256' },
      { internalType: 'uint256', name: 'negativeVotes', type: 'uint256' },
      { internalType: 'uint256', name: 'totalVotes', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    name: 'hasUserVotedToday',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getTotalUsers',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'voters',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    name: 'getUserStreak',
    outputs: [
      { internalType: 'uint256', name: 'currentStreak', type: 'uint256' },
      { internalType: 'uint256', name: 'lastVote', type: 'uint256' },
      { internalType: 'uint256', name: 'longestStreakCount', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    name: 'getUserVoteStats',
    outputs: [
      { internalType: 'uint256', name: 'bullishCount', type: 'uint256' },
      { internalType: 'uint256', name: 'bearishCount', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'voter', type: 'address' },
      { indexed: true, internalType: 'uint256', name: 'dateKey', type: 'uint256' },
      { indexed: false, internalType: 'enum BaseVibe.VoteOption', name: 'option', type: 'uint8' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'VoteCast',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'voter', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'newStreak', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'dateKey', type: 'uint256' },
    ],
    name: 'StreakUpdated',
    type: 'event',
  },
] as const



